import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { routes } from './routes';
import ProtectedRoute from './ProtectedRoute';
import Login from '../pages/Login';
import RecuperarSenha from '../pages/RecuperarSenha';
import ErrorPage from '../pages/ErrorPage';
import NotFound from '../pages/NotFound';
import MassaInicial from '../pages/MassaInicial';
import TermoResponsabilidade from '../pages/TermoResponsabilidade';

const Routes = () => {
  const { loggedIn } = useSelector((state) => state.auth);
  return (
    <>
      <Switch>
        {routes.map((r) => (
          <ProtectedRoute
            exact
            key={r.id}
            path={`/novo${r.url}`}
            component={r.component}
            isPrivate={r.isPrivate}
            roles={r.roles}
          />
        ))}
        <Route exact path="/novo/massa-inicial" component={MassaInicial} />
        <Route
          exact
          path="/novo/massa-inicial/termo-responsabilidade"
          component={TermoResponsabilidade}
        />
        <Route exact path="/novo/recuperar-senha" component={RecuperarSenha} />
        <Route exact path="/novo/login*" component={Login} />
        <Route exact path="/novo/error" component={ErrorPage} />
        <ProtectedRoute isPrivate path="*" component={NotFound} />
      </Switch>
    </>
  );
};

export default Routes;
